const financeDetails = 'lowerBound:500,upperBound:9999,months:36,deposit:10-lowerBound:500,upperBound:9999,months:12,deposit:10lowerBound:500,upperBound:9999,months:24,deposit:10-lowerBound:500,upperBound:9999,months:48,deposit:10';
const financeDetailsArray = financeDetails.split('-');
let financeDetailsObjectArray = [], allFinanceOptions = [];
let test = [];

financeDetailsArray.forEach((element) => {
  let splitElement = element.split(',')
  financeDetailsObjectArray.push(splitElement)
});


let total;

function getTotal() {  
  total = $('.totalPrice').text().replace(/\D/g,'');
  total = Number(total);
  return total;
}

financeDetailsObjectArray.forEach((array) => {
  let objects = [], objectArray;
  array.forEach((element) => {
    objectArray = []
    let splitArray = element.split(':');
    let property = splitArray[0], value = Number(splitArray[1]);
    let object = [property, value]
    objects.push(object)
    let map = new Map(objects);
    let obj = Object.fromEntries(map);
    objectArray.push(obj)
  });
  total = getTotal();
  if (total >= objectArray[0].lowerBound && total < objectArray[0].upperBound) {
    allFinanceOptions.push(objectArray);
  }
});

allFinanceOptions = allFinanceOptions.flat();
let financeMonths = allFinanceOptions.map(a => a.months).sort();
let financeDeposits = allFinanceOptions.map(a => a.deposit);
financeDeposits.push(20, 25, 30, 35, 40, 45, 50);
financeDeposits = financeDeposits.sort();
financeDeposits = [...new Set(financeDeposits)];

var matchedFinanceOptions = allFinanceOptions.filter(option => {
  let total = getTotal();
  return total >= option.lowerBound && total < option.upperBound
})

let matchedFinanceFirst = matchedFinanceOptions[0];
var matchedFinanceLower = matchedFinanceFirst.lowerBound,
    matchedFinanceUpper = matchedFinanceFirst.upperBound,
    matchedfinanceMonths = matchedFinanceFirst.months,
    matchedFinanceDeposit = matchedFinanceFirst.deposit;

function calculateMonthlyFinancePrice(total) {
  let monthlyInstallment;
  let depositText = "";
  monthlyInstallment = ((total/matchedfinanceMonths) / 100 * (100 - matchedFinanceDeposit)).toFixed(2);
  depositText = `${matchedFinanceDeposit}% deposit required.`;
  
  /*
  <img src="https://cdn.shopify.com/s/files/1/0052/6879/9591/files/V12.png?v=1663861290" id="v12Icon">
  */
  $(".monthlyFinancePrice").text(`£${monthlyInstallment}`);
  $("#depositText").text(depositText);
}

function getDepositValue(value) {
  var depositValue = (total / 100 * value).toFixed(2);
  var depositValueString = `£${depositValue}`;
  return depositValueString;
}

function displayDepositButtons() {
  $('#offCanvasWrapper').find('.buttonWrapper').html('');
  $.each(financeDeposits, function(index, value) {
  let $depositPercentageButton = $("<div>")
    .text(`${value}%`)
    .attr('data-percentage', value)
    .addClass("percentageButton")
    .click(function() {
      $(this).addClass('active');
      $(this).siblings().removeClass('active');
      displayInstallmentAmounts(value);
      $(".depositValue").text(getDepositValue(value));
    });
    $(".buttonWrapper").attr("data-child-count", financeDeposits.length);
    $('#offCanvasWrapper').find('.buttonWrapper').each(function() {
      $(this).append($depositPercentageButton);
    });
  });
}

function displayInstallments() {
  $('#offCanvasWrapper').find('.table').html('');
  let $monthInstallmentsHeader = $("<div>")
    .addClass("tableRow")
    .html("Months <span>Monthly Amount</span>");
  $('#offCanvasWrapper').find('.table').append($monthInstallmentsHeader);
  
  $.each(financeMonths, function(index, value) {
    let $monthInstallments=$("<div>")
      .html(`${value} <span class="FinanceField" data-monthAmount = ${value}>0</span>`)
      .addClass("tableRow");
    $('#offCanvasWrapper').find('.table').append($monthInstallments);      
  });
}

function displayInstallmentAmounts(percentageAmount) {
  let minusPercent = getTotal() * (percentageAmount / 100);
  $('#offCanvasWrapper').find(".FinanceField").each(function() {
    let monthAmount = $(this).attr("data-monthAmount");
    let monthAmountTotal = (getTotal() - minusPercent) / monthAmount;

    let test = matchedFinanceOptions.find((e) => e.months == monthAmount);
    if (test !== undefined && percentageAmount >= test.deposit) {
      $(this).text("£" + monthAmountTotal.toFixed(2));
    }
    else {
      $(this).text("N/A*");
    }
  });
  calculateMonthlyFinancePrice(total);
}

function displayInitialInstallmentAmounts(total) {
  let initialSelectedPercentage = financeDeposits[0];
  displayInstallmentAmounts(initialSelectedPercentage);

  $('#offCanvasWrapper').find(".percentageButton").each(function() {
    if ($(this).text() == `${initialSelectedPercentage}%`) {
      $(this).click();
    }
  });
  $('#productInfoContainer').find(".percentageButton").each(function() {
    if ($(this).text() == `${initialSelectedPercentage}%`) {
      $(this).click();
    }
  });
}
  
$(document).ready(function() {
  if ($(".monthlyFinancePrice").length) {
    displayDepositButtons();
    displayInstallments();
    displayInitialInstallmentAmounts(total);
  }

  $('.financeCalcButton').click(function() {
    $("body").addClass("scrollingDisabled");
    $('.popupContainer').addClass("visible");
  });
  $('.fa-xmark').click(function() {
    $("body").removeClass("scrollingDisabled");
    $('.popupContainer').removeClass("visible");
  });
});